import React from "react";

// Display-only full-screen background for the final 10s countdown (never clickable,
// so nothing pulls a racer away). No CSS animation/transform: iOS Low Power Mode can
// leave an entry animation stuck on its first (invisible) frame. Sponsor takeover fills the phone; otherwise a
// branded Text Racing backdrop. Race UI is layered above this (z-10).
// Safe zones of the 1080x2340 creative (fractions of screen height), shared by the
// race screen, the advertiser preview overlay and the AI builder guidance.
export const TAKEOVER_TOP = 0.14;      // 0-14%  : brand logo
export const TAKEOVER_BOTTOM = 0.58;   // 14-58% : covered by race card + Live Positions; 58-100%: message

export const CountdownTakeover = ({ ad }) => {
  const a = ad?.ad;
  const img = a?.image_url;
  return (
    <div className="fixed bottom-0 inset-x-0 mx-auto w-full max-w-[430px] z-0 overflow-hidden bg-race-bg pointer-events-none select-none"
      style={{ top: "calc(env(safe-area-inset-top, 0px) * -1)" }} aria-hidden="true" data-testid={img ? "countdown-takeover" : "countdown-takeover-fallback"}>
      {img ? (
        <img src={img} alt="" draggable={false} decoding="sync" className="absolute inset-0 w-full h-full object-cover object-top" data-testid="countdown-takeover-img" />
      ) : (
        <>
          <div className="absolute inset-0" style={{ background: "radial-gradient(120% 45% at 50% 0%, rgb(var(--c-accent) / 0.14), transparent 70%), radial-gradient(120% 50% at 50% 100%, rgb(var(--c-accent) / 0.10), transparent 70%)" }} />
          <div className="absolute inset-x-0 bottom-[8%] text-center">
            <div className="font-mono text-[10px] uppercase tracking-[0.35em] text-race-sub">IBRA sanctioned</div>
            <div className="font-heading text-6xl leading-none text-race-txt/10 mt-2">TEXT RACING</div>
          </div>
        </>
      )}
    </div>
  );
};

export default CountdownTakeover;
